export default {
  NONE: 0,
  GUEST_PASS: 1,
  ACCESS: 2,
  DEBITWARE: 3
};
